var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2261",
    "data-name": "Group 2261",
    transform: "translate(10113 -8116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2259",
    "data-name": "Group 2259",
    transform: "translate(-10143 8018)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(30 98)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2243",
    "data-name": "Group 2243",
    transform: "translate(10191 -8006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2235",
    "data-name": "Group 2235",
    transform: "translate(-10154 8110)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3563",
    "data-name": "Path 3563",
    d: "M-809.532,1918.209l-4.287,4.125a1.089,1.089,0,0,0-.334.785v5.8a1.089,1.089,0,0,0,1.089,1.089h8.575a1.089,1.089,0,0,0,1.089-1.089v-5.8a1.089,1.089,0,0,0-.334-.785l-4.287-4.125A1.089,1.089,0,0,0-809.532,1918.209Z",
    transform: "translate(814.153 -1917.905)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1310",
    "data-name": "Rectangle 1310",
    d: "M2.042,0h0A2.042,2.042,0,0,1,4.083,2.042V4.9a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.042A2.042,2.042,0,0,1,2.042,0Z",
    transform: "translate(3.335 7.2)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e3e3f535d68e2cfce2e5768805f3f43e.svg";
export { ForwardRef as ReactComponent };